const DATE_FORMAT = 'MMM DD, YYYY';

export { DATE_FORMAT };
